import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const PersonalizedSlipsSettingsCard = memo(
  function PersonalizedSlipsSettingsCard({
    input,
  }: {
    input: OutboundLabelForm;
  }) {
    const { personalizedSlipsEnabled } = input.inputs;

    return (
      <Card title="Personalized Slips">
        <Flex dir="column" gap="lg">
          <RedoToggle
            label="Enable Personalized Slips"
            setValue={personalizedSlipsEnabled.setValue}
            value={personalizedSlipsEnabled.value}
          />
          <Text fontSize="xs" textColor="secondary">
            When enabled, merchants can create and print personalized inserts
            with AI-generated content, product recommendations, and discount
            codes.
          </Text>
        </Flex>
      </Card>
    );
  },
);
